<template>
  <div id='tiny'>
    <Editor v-model='value.html' @input='textChanged' :init="{
      height: 500,
      menubar: true,
      plugins: [
        'advlist autolink lists link image charmap print preview anchor',
        'searchreplace visualblocks code fullscreen',
        'insertdatetime media table paste code help wordcount'
      ],
      branding: false,
      toolbar:
      'undo redo | formatselect | bold italic backcolor | \
      alignleft aligncenter alignright alignjustify | \
      bullist numlist outdent indent | removeformat | help'
    }"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/silver';
import 'tinymce/skins/ui/oxide/skin.min.css';
import 'tinymce/skins/ui/oxide/content.min.css'
import 'tinymce/skins/content/default/content.min.css'
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/print';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/media';
import 'tinymce/plugins/table';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/code';
import 'tinymce/plugins/help';
import 'tinymce/plugins/wordcount';

import Editor from '@tinymce/tinymce-vue';

export default {
  name: 'TinyMCE',
  components: {
    Editor
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  watch: {
    value() {
      this.$emit('input', this.value)
    }
  },
  methods: {
    textChanged(evt) {
      if (this.value) this.value.modified = true;
      this.$emit('textChanged')
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
